<!-- 全局变量模块-->
<template></template>
<script>
let devmode = process.env.DEV_MODE; //开发模式
let WEB_URL = ""; //访问域名
let BASE_URL = ""; //接口地址
let borwser = getborwser();
let APPID = ""; //appid
switch (devmode) {
  case "dev": //开发库
    WEB_URL = "http://localhost:8081";
      BASE_URL = "http://localhost:15555/";
      
      BASE_URL = "http://nongjiaapi.zhoumochuyou.cn/";
    APPID = "wx4e3eeca00c2dfe61"; //游世界技术测试appid
      //BASE_URL = "http://test.nongjiaapi.zhoumochuyou.cn/";
    break;
  case "beta": //测试库
    WEB_URL = "http://test.nongjia.zhoumochuyou.cn/";
    var url = window.location.href;
    var arry = url.split(":");
    if (arry[0] == "http") {
      BASE_URL = "http://test.nongjiaapi.zhoumochuyou.cn/";
    } else {
      BASE_URL = "https://test.nongjiaapi.zhoumochuyou.cn/";
    }
    APPID = "wx4e3eeca00c2dfe61"; //游世界技术测试appid
    break;
  case "pro": //生产库
    WEB_URL = "http://nongjia.zhoumochuyou.cn/";
    var url = window.location.href;
    var arry = url.split(":");
    if (arry[0] == "http") {
      BASE_URL = "http://nongjiaapi.zhoumochuyou.cn/";
    } else {
      BASE_URL = "https://nongjiaapi.zhoumochuyou.cn/";
      WEB_URL = "https://nongjia.zhoumochuyou.cn/";
    }
    APPID = "wx4e3eeca00c2dfe61"; //游世界技术测试appid
    break;
  default:
    break;
}

// const WEB_URL = "http://mdis.zhoumochuyou.com/";
//const BASE_URL = getbaseurl(); //生产环境
//const BASE_URL = "http://test.mapi.zhoumochuyou.com/";//测试环境
//const BASE_URL = "http://localhost:15641/";//开发环境
export default {
  borwser: borwser,
  BASE_URL: BASE_URL,
  WEB_URL: WEB_URL,
  appid: APPID, //周末游appid
  redirect_uri: encodeURIComponent(WEB_URL)
};
// function getbaseurl(){
//   //debugger
//    var protecturl=document.location.protocol;
//    var baseurl="http://mapi.zhoumochuyou.com/";
//    if(protecturl=="https:"){
//        baseurl="https://mapi.zhoumochuyou.com/";
//    }
//    return baseurl;
// }

function getborwser() {
  var ua = window.navigator.userAgent.toLowerCase();
  var b = "";
  if (ua.indexOf("micromessenger") > -1) {
    b = "wechat";
  } else if (ua.indexOf("qq") > -1) {
    b = "qq";
  } else if (ua.indexOf("weibo") > -1) {
    b = "weibo";
  } else {
    b = "";
  }
  return b;
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/global/global.vue